module.exports = __webpack_public_path__ + "media/mps_video.07f2da5f.mp4";